import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import useDashboardStore from '../store/dashboardStore';

// Move component outside render to prevent recreation on each render
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: 'rgba(10, 10, 15, 0.95)',
        border: '1px solid rgba(102, 126, 234, 0.3)',
        borderRadius: '8px',
        padding: '10px',
      }}>
        <p style={{ color: '#00d4ff', marginBottom: '5px' }}>{label}</p>
        <p style={{ color: '#667eea' }}>
          Revenue: ${payload[0]?.value?.toLocaleString()}
        </p>
        {payload[1] && (
          <p style={{ color: '#22c55e' }}>
            Profit: ${payload[1]?.value?.toLocaleString()}
          </p>
        )}
      </div>
    );
  }
  return null;
};

const RevenueChart = () => {
  const { chartData } = useDashboardStore();

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h3 className="chart-title">Revenue Analytics</h3>
        <select
          className="quantum-btn"
          style={{
            padding: '8px 16px',
            fontSize: '0.9rem',
            background: 'rgba(102, 126, 234, 0.2)',
            border: '1px solid rgba(102, 126, 234, 0.3)',
          }}
        >
          <option>Last 7 Days</option>
          <option>Last 30 Days</option>
          <option>Last Quarter</option>
        </select>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(102, 126, 234, 0.1)" />
          <XAxis
            dataKey="name"
            stroke="rgba(255, 255, 255, 0.5)"
            style={{ fontFamily: 'Orbitron, monospace' }}
          />
          <YAxis
            stroke="rgba(255, 255, 255, 0.5)"
            style={{ fontFamily: 'Orbitron, monospace' }}
            tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            wrapperStyle={{
              fontFamily: 'Orbitron, monospace',
              color: 'rgba(255, 255, 255, 0.7)'
            }}
          />
          <Line
            type="monotone"
            dataKey="revenue"
            stroke="#667eea"
            strokeWidth={3}
            dot={{ fill: '#00d4ff', r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="profit"
            stroke="#22c55e"
            strokeWidth={2}
            dot={{ fill: '#22c55e', r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueChart;
